import hasFeature from 'modules/core/lib/hasFeature'

import allowances from 'modules/timeoff/store/collections/allowances'
import policyTimelines from 'modules/timeoff/store/collections/timeoffPolicies/policyTimelines'
import type Allowance from 'modules/timeoff/store/models/Allowance'

export const employeeAllowances = (employeeTimeoffPolicyId: number): Allowance[] => {
  if (hasFeature('timeoff_policy_timeline')) {
    return allowances.filter({
      timeoff_policy_id: policyTimelines.timeline?.current.timeoff_policy_id,
    })
  }

  return allowances.filter({
    timeoff_policy_id: employeeTimeoffPolicyId,
  })
}
